"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TAAErrorBoundary = void 0;
const react_1 = __importDefault(require("react"));
const react_error_boundary_1 = require("react-error-boundary");
const logger_1 = require("../../../logger");
const ErrorFallback_1 = require("../../../components/Shared/ErrorFallback");
const errorHandler = (error, info) => {
    logger_1.logger.fatal(error.message, error, { info });
};
const TAAErrorBoundary = ({ children }) => (react_1.default.createElement(react_error_boundary_1.ErrorBoundary, { FallbackComponent: ErrorFallback_1.ErrorFallback, onError: errorHandler }, children));
exports.TAAErrorBoundary = TAAErrorBoundary;
